<ng-container *transloco="let t; prefix: 'payment.wizard.stepOne'">
    <!-- Header -->
    <div class="flex flex-col w-full gap-2 items-center justify-center">
        <h2 class="rfs:text-[40px] text-center font-semibold text-black">
            {{t('header')}}
        </h2>
        <p class="rfs:text-xl text-center font-light text-tone-09">
            {{t('infoText')}}
        </p>
    </div>
    <!-- END OF Header -->

    <!-- Select entry Button group by category -->
    <div class="flex justify-center w-full max-w-[800px]">
        <app-tab-pill-group-button class="flex-1" [items]="tabPillGroupButtons"
            (itemSelected)="handleButtonGroupItemSelected($event)" />
    </div>
    <!-- END OF Select entry Button group by category -->

    <!-- Input value based on the selected type -->
    @if (this.caseItem === 'my-listings') {
    <app-filter-property-dropdown class="flex flex-1 w-full max-w-[800px]"
        [dropdownItems]="dropdownPropertyItems"
        [labelName]="'Επίλεξε καταχώριση'" [maxHeightOnDropdownOpen]="'52'"
        inputPlaceholder="Selection" />
    } @else if (this.caseItem === 'favorites' ) {
    <app-filter-property-dropdown class="flex flex-1 w-full max-w-[800px]"
        [dropdownItems]="dropdownPropertyItems"
        [labelName]="'Επίλεξε καταχώριση'" [maxHeightOnDropdownOpen]="'52'"
        inputPlaceholder="Selection" />
    } @else if (this.caseItem === 'enter-code' ) {
    <!-- Manul input -->
    <div class="flex w-full max-w-[800px]">
        <div class="flex flex-col gap-2 group/input md:w-2/4 w-full">
            <label class="flex items-center gap-2 text-gray-950 font-semibold">Κωδικός καταχώρισης
                <span class="text-error">*</span><i class="icon-info-circle text-tone-06 text-xl"></i>
            </label>
            <input
                class="flex items-start text-left px-4 py-3 border-[1px] rounded-full bg-white text-md text-black border-gray-300" />
        </div>
    </div>
    }
    <!-- END OF Input value based on the selected type -->
</ng-container>